












































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { mapGetters, mapState } from 'vuex'
import { Ability } from '@/types/Ability'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ExaGenericTable from '@exatech-group/generic-table/src/GenericTable.vue'
import CapacitesPhaseSuivante from '@/components/DefinitionDesBarres/CapacitesPhaseSuivante.vue'
import Comparaisons from '@/components/DefinitionDesBarres/Comparaisons.vue'
import Back from '@/components/Tools/Back.vue'
import store from '@/store'
import { formatDate, dateisSameOrBefore } from '@/utils/helpers'
import _ from 'lodash'
import { BarRuleType, BarTypePass } from '@/types/Barre'

@Component({
    computed: {
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA', 'user_session_id']),
        ...mapState('auth', ['user', 'authUser', 'user_session_id']),
        ...mapState('phase', ['phases']),
        ...mapState('definitionDesBarres', ['old_saisie', 'new_saisie']),
        ...mapGetters('definitionDesBarres', [
            'tableauDesConcours',
            'meta',
            'links',
            'loading',
            'error',
            'currentPage',
            'lastPage',
            'totalPage',
            'totalRows',
            'work_in_progress'
        ])
    },
    components: {
        ExaGenericTable,
        FontAwesomeIcon,
        CapacitesPhaseSuivante,
        Comparaisons,
        Back
    },
    beforeRouteLeave(to, from, next) {
        if (store.getters['definitionDesBarres/work_in_progress']) {
            const result = confirm('Vous allez quitter la page. Des saisies ne sont pas sauvegardées. Souhaitez-vous les enregistrer avant de continuer votre navigation ?')
            if (result) {
            // TODO : Appel de la sauvegarde avant de poursuivre
                next();
            }
        } else {
            next();
        }

    }
})
export default class DefinirBarresConcours extends Vue {
    Ability = Ability
    formatDate = formatDate

    sortBy = ''
    sortDesc = false
    sortDirection = 'asc'
    filter = ''
    filterOn = []
    stickyHeader = true
    filtres: any = []
    dataForTab: Array<any> = []
    genericfields: Array<any> = []
    params: any = null
    exportingIsWorking = false
    showCapacites = false
    showComparaisons = false
    barres_actives: Array<any> = []
    phase_id_select = null
    showValidationBarres = false
    showAlerteSauvegarde = false
    valide = 1
    last_save: any = null

    hiddenBarres = [
        BarTypePass.BAR_TYPE_ANONYMOUS
    ]

    // ----------------- pour test ---------------------------------
    modeMonoColonneBarre = false   
    // -------------------------------------------------------------

    showParametrageExportation = false
    selected_tab = 'comparaison'
    saisieIsOpen = true

    @Watch('user_session_id')
    refreshInterface() {
        this.load()
    }

    @Watch('barres_actives')
    getTableauConcours() {
        this.setDataForGenericTab(this.$store.getters['definitionDesBarres/tableauDesConcours'])
    }

    @Watch('phase_id_select')
    reloadConcours () {
        this.load()
    }

    
    closeParametrageExportation () {
        this.showParametrageExportation = false
    }

    openParametrageExportation () {
        this.showParametrageExportation = true
    }

    switchSaisieHandler() {
        this.saisieIsOpen = !this.saisieIsOpen
    }

    // Change le flag d'enregistrement car des données sont modifiées et non enregistrées
    update_work () {
        // Compare la saisie en cours à la dernière pour voir s'il y a eu des modifs
        const compare_old = JSON.stringify(this.$store.state.definitionDesBarres.old_saisie)
        const compare_actual = JSON.stringify(this.$store.state.definitionDesBarres.saisie_en_cours)
        if (compare_actual !== compare_old) {
            this.$store.commit('definitionDesBarres/SET_WORK_PROGRESS', true)
            this.setDataForGenericTab(this.$store.getters['definitionDesBarres/tableauDesConcours'])
        } 
    }

    // TODO : Création dynamique des entêtes de colonnes
    // -> Colonnes dynamiques pour les groupes de comparaisons : 1 groupe = 1 colonne
    create_fields (poData: any = null) {
        this.genericfields = []
        this.barres_actives = []
        const tableauDesConcours = this.$store.getters['definitionDesBarres/tableauDesConcours']

        this.genericfields.push({ key: 'concour.name', label: 'Concours', sortable: true, class: '', type: 'text' })
        this.genericfields.push({ key: 'concour.banque.name', label: 'Filière', sortable: true, class: '', type: 'text' })
        if(this.modeMonoColonneBarre){
            this.genericfields.push({ key: 'barres', label: 'Barres', sortable: false, class: 'text-center', type: 'html' })
        } else {
            // Parcours des lignes pour récupérer les barres actives
            for (const concour of tableauDesConcours) {
                
                for (const barre of concour.deliberation.barres) {
                    if(!this.hiddenBarres.includes(barre.type)) {
                        for(const threshold of barre.thresholds){
                            if (this.barres_actives.length !== 0) {
                                const check_barre = this.barres_actives.find((b: any) => String(b.id) === String(threshold.bar_rule_id) )
                                if (!check_barre) { 
                                    //this.barres_actives.push(threshold)
                                    this.barres_actives.push({
                                        id: threshold.bar_rule_id,
                                        name: barre.name + ' - ' + this.getBarreRuleByIdOfConcour(threshold.bar_rule_id, concour).name
                                    })
                                }
                            } else{ 
                                this.barres_actives.push({
                                    id: threshold.bar_rule_id,
                                    name:  barre.name + ' - ' + this.getBarreRuleByIdOfConcour(threshold.bar_rule_id, concour).name
                                })
                            }
                        }
                    }
                }
                
            }
    
            for (const barre of this.barres_actives) {
                this.genericfields.push({ key: 'barre_' + barre.id, label: barre.name, sortable: false, class: '', type: 'text' })
            }
        }


        

        this.genericfields.push({
            key: 'validate',
            label: 'Validation',
            sortable: true,
            class: 'text-center',
            type: 'text'
        })

        this.genericfields.push({ key: 'updated_at', label: 'Dernière modification', sortable: false, sortDirection: 'asc', class: '' })

        this.genericfields.push({ key: 'candidats_inscrits', label: 'Candidats inscrits', sortable: true, class: 'text-center', type: 'text' })

        this.genericfields.push({ key: 'candidats admis', label: 'Candidats Admis', sortable: true, class: 'text-center', type: 'text' })


        /*
        if(this.modeMonoColonneBarre){
            this.genericfields.push({ key: 'candidats', label: 'Candidats', sortable: true, class: 'text-center', type: 'text' })
        } else {
            for (const barre of this.barres_actives) {
                this.genericfields.push({ key: 'candidats_' + barre.id, label: 'Candidats ' + barre.name, sortable: true, class: 'text-center', type: 'text' })
            }
        }*/
        
        // TODO : A remplacer par dynamique
        /*
        this.genericfields.push({ key: 'comparaison_oc', label: 'OC', sortable: true, class: 'barre_tertiary text-center', type: 'text', doubleHeaderLabel: 'Comparaisons', doubleHeaderColSpan: 3, doubleHeaderClass: 'barre_tertiary text-center text-uppercase' })
        this.genericfields.push({ key: 'comparaison_oc_ensam', label: 'OC + ENSAM', sortable: true, class: 'barre_tertiary text-center', type: 'text' })
        this.genericfields.push({ key: 'comparaison_estp', label: '+ ESTP', sortable: true, class: 'barre_tertiary text-center', type: 'text' })
        */

        this.setDataForGenericTab(poData ? poData : tableauDesConcours)
    }

    // Création des lignes du tableau
    setDataForGenericTab(poData: any, isLoadMore = false) {
        if (!isLoadMore) {
            this.dataForTab = []
        }

        const dataTemp  = []
        if (poData) {
            for (const result of poData) {
                const concour = result && result.concour && result.concour.name ? result.concour.name : '-'
                const filiere =
                    result && result.concour && result.concour.banque && result.concour.banque.name
                        ? result.concour.banque.name
                        : '-'


                const line: any = [
                    { label: '', item: concour, type: 'text', typeAction: null, class: '' },
                    { label: '', item: filiere, type: 'text', typeAction: null, class: '' }
                ]

                const countBarreWithoutAnonymous =  this.getCountBarreWithoutAnonymous(result)

                if(this.modeMonoColonneBarre){
                    let items = '<div class="row">'
                
                    for(const barreDelib of result.deliberation.barres) {
                        if(!this.hiddenBarres.includes(barreDelib.type)) {
                            items += '<div class="col-' + (12 / countBarreWithoutAnonymous) + '">'
                            for(const threshold of barreDelib.thresholds) {
                                const nameTemp = barreDelib.name + ' - ' + (this.getBarreRuleByIdOfConcour(threshold.bar_rule_id, result) ? this.getBarreRuleByIdOfConcour(threshold.bar_rule_id, result).name : '')
                                items += '<div class="mb-1 mt-0" style="font-size: 11px;">' + nameTemp + ': </div><input type="number" data-resultid="'+result.id+'" data-barreid="'+barreDelib.id+'" data-barruleid="' + threshold.bar_rule_id + '" value="' + (threshold.value ? threshold.value : '') + '" step="1" min="0" ref="inputbarre" class="inputbarre form-control form-control-sm" />'
                            }
                            items += '</div>'
                        }
                    }
                
                    items += '</div>'
                    line.push({
                        label: 'Barres',
                        item: items,
                        type: 'html',
                        typeAction: null,
                        class: 'text-center'
                    })

                } else {

                    for (const barre of this.barres_actives) {
                        let check_barre: any = null
                        // const check_barre = result.deliberation.bar_rules.find((b: any) => b.id === barre.id)
                        for(const barreDelib of result.deliberation.barres) {
                            for(const threshold of barreDelib.thresholds) {
                                if(threshold.bar_rule_id === barre.id) {
                                    check_barre = threshold
                                }
                            }
                        }
                        if (check_barre) {     
                            check_barre.concour_phase_id = result.id
                            line.push({ 
                                label: '', 
                                item: check_barre.value, 
                                data: check_barre, 
                                type: 'inputNumber', 
                                typeAction: 'input_barre', 
                                minInput: 0, 
                                class: 'item_action fixed_size_input_table_gen text-center', 
                                disabled: false, 
                                nullEnabled: false 
                            })
                        } else {
                            line.push({ label: '', item: '', type: 'text', typeAction: null, class: '' })
                        }
                    }
                }

                line.push({
                    label:  (result.ajustements_validated_at ? 'Validé le ' + formatDate(result.ajustements_validated_at) : 'Non validé'),
                    item: [{ name: 'circle', class: (result.ajustements_validated_at ? 'text-success' : 'text-tertiary'), title: (result.ajustements_validated_at ? 'Validé le ' + formatDate(result.ajustements_validated_at) : 'Non validé')}],
                    type: 'icons',
                    typeAction: null,
                    class: 'text-center'
                })


                if((this.last_save === null && result.updated_at) || (this.last_save && result.updated_at && dateisSameOrBefore(this.last_save, result.updated_at))) {
                    this.last_save = result.updated_at
                }
                if((this.last_save === null && result.ajustements_validated_at) || (this.last_save && result.ajustements_validated_at && dateisSameOrBefore(this.last_save, result.ajustements_validated_at))) {
                    this.last_save = result.ajustements_validated_at
                }
                const updated_at_icon = [{ 
                    name: 'clock', 
                    class: 'text-info text-small', 
                    title: (result.updated_at ? formatDate(result.updated_at) : '-'), 
                    value_comp: (result.updated_at ? formatDate(result.updated_at) : (result.ajustements_validated_at ? formatDate(result.ajustements_validated_at)  : ' - ')) 
                }]



                line.push({ label: '', item: updated_at_icon, type: 'icons', typeAction: null, class: 'text-center' })

                line.push({ label: '', item: result.candidats_count, type: 'text', typeAction: null, class: 'text-center' })

                line.push({ label: '', item: '-', type: 'text', typeAction: null, class: 'text-center' })


                /*
                if(this.modeMonoColonneBarre) {
                    let itemsCand = '<div class="row">'
                    for(const barreDelib of result.deliberation.barres) {
                        if(!this.hiddenBarres.includes(barreDelib.type)) {
                            itemsCand += '<div class="col-' + (12 / countBarreWithoutAnonymous) + '" style="font-size: 11px;">'
                            for(const threshold of barreDelib.thresholds) {
                                const nameTemp = barreDelib.name + ' - ' + (this.getBarreRuleByIdOfConcour(threshold.bar_rule_id, result) ? this.getBarreRuleByIdOfConcour(threshold.bar_rule_id, result).name : '')
                                itemsCand +=  nameTemp + ' :  <b> XX </b><br />'
                       
                            }
                            itemsCand += '</div>'
                        }
                    }
                    itemsCand += '</div>'
                    line.push({
                        label: 'Candidats',
                        item: itemsCand,
                        type: 'html',
                        typeAction: null,
                        class: 'text-center'
                    })
                
                    dataTemp.push(line)
                    this.dataForTab = dataTemp
        
                    const inputs = document.getElementsByClassName('inputbarre')
                    if(inputs.length > 0) {
                        for(let i =  0; i < inputs.length; i++) {
                            inputs[i].addEventListener('change', (e: any) => {
                                this.barreChangeHandler(e.target.value, e.target.getAttribute('data-resultid'), e.target.getAttribute('data-barreid'), e.target.getAttribute('data-barruleid'))
                            })
                        }
                    }

                } else {

                    for (const barre of this.barres_actives) {
                        const check_barre = result.deliberation.barres.find((b: any) => b.bar_rule_id === barre.id)
                        // console.log('barre', barre)
                        if (check_barre) {
                            line.push({ label: '', item: '-', type: 'text', typeAction: null, class: 'text-center' })
                        } else {
                            line.push({ label: '', item: '', type: 'text', typeAction: null, class: '' })
                        }
                    }
                    
                }
                */
                this.dataForTab.push(line)
            }
        }
    }

    barreChangeHandler (value: any, concourId: any, barreId: any, barruleId: any) {
        const concourTemp = this.$store.getters['definitionDesBarres/tableauDesConcours'].find((conc: any) => String(conc.id) === String(concourId))
        for(const barre of concourTemp.deliberation.barres) {
            if(String(barre.id) === String(barreId)) {
                for(const threshold of barre.thresholds) {
                    if(String(threshold.bar_rule_id) === String(barruleId)) {
                        threshold.value = value
                    }
                }
            }
        }
        const retour = {
            bar_rules: concourTemp.deliberation.bar_rules,
            barres: concourTemp.deliberation.barres
        }
        console.log(retour)

    }

    getCountBarreWithoutAnonymous (concour: any) {

        let count = 0;
        for(let i = 0; i < concour.deliberation.barres.length; i++) {
            if(!this.hiddenBarres.includes(concour.deliberation.barres[i].type)) {
                count++
            }
        }
        return count

    }

    getBarreRuleByIdOfConcour(id: any, concour: any) {
        for(const bar_rule of concour.deliberation.bar_rules){
            if(bar_rule.id === id) {
                return bar_rule
            }
        }
        return null
    }

    phases_options: Array<any> = []

    // Initialisation des filtres
    setFiltersForGenericTab() {
        this.$store.dispatch('banque/getBanques', { perPage: 0 }).then(() =>{
            const deroulant_banques = this.$store.getters['banque/banques'].map((banque: any) => {
                return { index: banque.id, name: banque.name }
            })
    
            for (let i = 0; i < this.$store.getters['banque/banques'].length; i++) {
                for ( let j = 0; j < this.$store.getters['banque/banques'][i].phases.length; j++) {
                    if( i === 0 &&  j === 0) {
                        this.phase_id_select = this.$store.getters['banque/banques'][i].phases[j].phase_id
                    }
                    const optTemp:any = {id:this.$store.getters['banque/banques'][i].phases[j].phase_id, name: this.$store.getters['banque/banques'][i].phases[j].name }
                    if(this.phases_options.length === 0 || !this.phases_options.find((p: any) => p.id === optTemp.id)){
                        this.phases_options.push(optTemp)
                    }
                }
            }
    
            this.$store.dispatch('concour/getConcours', { perPage: 0 }).then(() => {
                const concours = this.$store.getters['concour/concours']
                const deroulant_concours = concours.map((concour: any) => {
                    return { index: concour.id, name: concour.name }
                })
        
                this.filtres = [
                    {
                        libelle: 'Concours',
                        defautOptionlibelle: 'Rechercher un',
                        model: 'concour.name',
                        value: '',
                        index: 'concour.name',
                        datas: deroulant_concours,
                        loading: this.$store.getters['definitionDesBarres/loading'],
                        options: { type: 'deroulant', fieldsKey: 'concour.name', strict: true }
                    },
                    {
                        libelle: 'Filière',
                        defautOptionlibelle: 'Rechercher une',
                        model: 'banque_name',
                        value: '',
                        index: 'banque_name',
                        datas: deroulant_banques,
                        loading: this.$store.getters['definitionDesBarres/loading'],
                        options: { type: 'deroulant', fieldsKey: 'concour.banque.name', strict: true }
                    }
                ]
                this.load()
            })
        })
    }

    // Evenements du tableau
    handleTableEvent(paParams: any): void {
        if (paParams && paParams[0] && paParams[1]) {
            switch (paParams[0]) {
                case 'sortHandler':
                    this.filtreSortHandler(paParams[1])
                    break

                case 'filterHandler':
                    this.filtreSortHandler(paParams[1])
                    break

                case 'onLoadPage':
                    this.loadHandler(paParams[1])
                    break

                case 'input_barre':
                    paParams[2].value = paParams[1]
                    // this.update_work()
                    console.log('--------input_barre----------')
                    console.log(paParams)
                    console.log('------------------')
                    break
                default:
                    break
            }
        }
    }

    // Chargement des résultats
    loadHandler(params: any) {
        Vue.set(params, 'filter-phase_id', this.phase_id_select)
        if (JSON.stringify(this.params) !== JSON.stringify(params)) {
            this.params = params
            this.$store
                .dispatch('definitionDesBarres/getMoreTableauDesConcours', params)
                .then(() => {
                    const tableauDesConccours: any = this.$store.getters['definitionDesBarres/tableauDesConcours']
                    if(tableauDesConccours) {
                        this.setDataForGenericTab(tableauDesConccours)
                    }
                })
                .catch((error) => {
                    console.log('ko:' + error)
                })
        }
    }

    // Applique les filtres
    filtreSortHandler(params: any) {
        Vue.set(params, 'filter-phase_id', this.phase_id_select)
        if (JSON.stringify(this.params) !== JSON.stringify(params)) {
            this.params = params
            this.$store
                .dispatch('definitionDesBarres/getTableauDesConcours', params)
                .then(() => {
                    this.create_fields(this.$store.getters['definitionDesBarres/tableauDesConcours'])
                    // this.setDataForGenericTab(this.$store.getters['definitionDesBarres/tableauDesConcours'])
                })
                .catch((error) => {
                    console.log('ko:' + error)
                })
        }
    }

    // TODO : Exporter
    // -> Cabler l'export
    exporter () {
        console.log('export')
    }

    // Ouvre la popup des capacités de la phase suivante
    show_capacites () {
        this.showCapacites = true
    }

    // Ferme la popup des capacités
    close_capacites () {
        this.showCapacites = false
    }

    // Ouvre la popup des comparaisons
    show_comparaisons () {
        this.showComparaisons = true
    }

    // Ferme la popup des comparaisons
    close_comparaisons () {
        this.showComparaisons = false
    }

    // TODO : Enregistre la saisie
    // -> Enregistrer la saisie des barres de tout les concours
    save () {
        console.log('save')
        this.$store.commit('definitionDesBarres/SET_WORK_PROGRESS', false)
        this.setDataForGenericTab(this.$store.getters['definitionDesBarres/tableauDesConcours'])
    }

    // Affiche la popup de validation / invalidation des barres
    show_validation_barres (valide: number) {
        this.valide = valide
        this.showValidationBarres = true
    }

    // Fermer la popup de validation / invalidation des barres
    cancel_validation_barres () {
        this.showValidationBarres = false
    }

    // TODO : Confirme la validation / invalidation des barres
    // -> Cabler la validation de toutes les barres
    confirm_validation_barres () {
        if (this.valide) {
            console.log('Validation des barres')
        } else {
            console.log('Invalidation des barres')
        }
    }

    load() {
        const params = {}
        Vue.set(params, 'filter-phase_id', this.phase_id_select)
        this.params = params
        this.$store
            .dispatch('definitionDesBarres/getTableauDesConcours' , params)
            .then(() => {
                this.create_fields()
            })
            .catch()
    }

    mounted() {
        if (this.$store.getters['auth/user_session_id'] !== null) {
            this.setFiltersForGenericTab()
        }
    }
}
